<template>
  <b-overlay
    variant="white"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
    :show="loading"
  >
    <DeleteBusinessTypeModal
      :business-type="businessTypeToBeChanged"
      @deleted="fetch"
      @hidden="businessTypeToBeChanged = undefined"
    />
    <BusinessTypeForm
      :business-type="businessTypeToBeChanged"
      @business-type-created="fetch"
      @hidden="businessTypeToBeChanged = undefined"
    />
    <b-card>
      <div class="d-flex align-items-center justify-content-between">
        <BFormCheckbox
          v-model="isActiveFilter"
          @change="fetch"
        >
          Is active
        </BFormCheckbox>
        <b-button
          class="mb-1"
          variant="primary"
          @click="openBusinessTypeModal"
        >
          Create new business type
        </b-button>
      </div>
      <b-table
        striped
        :items="list"
        :fields="tableColumns"
        show-empty
        empty-text="Empty"
      >
        <template #cell(actions)="data">
          <b-button
            v-if="$can('write', 'businesses-types')"
            class="btn-icon rounded-circle"
            variant="flat-primary"
            @click="openUpdateBusinessTypeModal(data.item)"
          >
            <feather-icon
              icon="EditIcon"
            />
          </b-button>
          <b-button
            v-if="$can('delete', 'businesses-types')"
            class="btn-icon rounded-circle"
            variant="flat-danger"
            @click="openDeleteBusinessTypeModal(data.item)"
          >
            <feather-icon
              icon="TrashIcon"
            />
          </b-button>
        </template>
      </b-table>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard, BTable, BOverlay, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import businessStore from '../../store'
import { formatDate } from '@/@core/utils/filter'
import BusinessTypeForm from '../../components/business-types/BusinessTypeForm.vue'
import DeleteBusinessTypeModal from '../../components/business-types/DeleteBusinessTypeModal.vue'

export default {
  components: {
    BCard, BTable, BOverlay, BButton, BusinessTypeForm, DeleteBusinessTypeModal, BFormCheckbox,
  },
  setup(_, ctx) {
    useRegisterStoreModule('business', businessStore)

    const businessTypeToBeChanged = ref()

    const tableColumns = [
      {
        label: 'Label',
        key: 'label',
      },
      {
        label: 'logical Id',
        key: 'logicalId',
      },
      {
        label: 'Description',
        key: 'description',
      },
      {
        label: 'active',
        key: 'active',
        formatter: val => (val ? 'Yes' : 'No'),
      },
      {
        label: 'created at',
        key: 'createdAt',
        formatter: val => formatDate(val),
      },
      'actions',
    ]
    const isActiveFilter = ref(true)
    const loading = ref(false)
    const list = ref([])

    const fetch = async () => {
      loading.value = true
      const res = await ctx.root.$store.dispatch('business/getBusinessTypes', {
        active: isActiveFilter.value || undefined,
      })
      const { data } = res.data.data
      list.value = data
      loading.value = false
    }

    fetch()

    const openBusinessTypeModal = () => ctx.root.$bvModal.show('business-types-form-modal')
    const openDeleteBusinessTypeModal = businessType => {
      businessTypeToBeChanged.value = { ...businessType }
      ctx.root.$bvModal.show('delete-business-type-modal')
    }
    const openUpdateBusinessTypeModal = docType => {
      businessTypeToBeChanged.value = { ...docType }
      setTimeout(() => {
        openBusinessTypeModal()
      }, 0)
    }

    return {
      isActiveFilter,
      openBusinessTypeModal,
      openDeleteBusinessTypeModal,
      openUpdateBusinessTypeModal,
      list,
      fetch,
      loading,
      businessTypeToBeChanged,
      tableColumns,
    }
  },
}
</script>
